module.exports = __webpack_public_path__ + "static/media/centuryGothic.8917856b.ttf";